import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BaseCta } from './BaseCta';
export var ReserveCta = function ReserveCta(_ref) {
  var className = _ref.className,
      creditPrice = _ref.creditPrice,
      onClick = _ref.onClick,
      tooltip = _ref.tooltip;
  return React.createElement(BaseCta, {
    className: classNames(className, 'bt--primary bt--outline'),
    onClick: onClick,
    tooltipProps: tooltip ? {
      'data-tooltip': tooltip
    } : null
  }, React.createElement("span", null, creditPrice), React.createElement(FormattedMessage, {
    id: "schedule.cta.reserve",
    defaultMessage: "credits"
  }));
};
ReserveCta.propTypes = {
  className: PropTypes.string,
  creditPrice: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string
};